import authHelper from '../../helpers/auth';
import apiAuth from '../../api/auth';
import alertHelper from '../../helpers/alert';

const defaultState = () => ({
    isAuth: authHelper.loggedIn(),
    isAttempting: false,
    alerts: [],
    fieldErrors: {},
    userData: authHelper.getUserData(),
    userMenu: authHelper.getMenu()
});

const state = defaultState();

const getters = {
    isAuth(state) {
        return state.isAuth;
    },
};

const mutations = {
    attempting(state) {
        state.isAttempting = true;
        state.fieldErrors = {};
        state.alerts = [];
    },
    attempted(state) {
        state.isAttempting = false;
    },
    failed(state, { code, type, message }) {
        state.alerts = alertHelper.make(state.alerts, code, type, message);
    },
    validationError(state, errors) {
        state.fieldErrors = errors;
    },
    success(state, authData) {
        authHelper.setData(authData);
        state.userData = authHelper.getUserData();
        state.userMenu = authHelper.getMenu()
        state.isAuth = true;
        state.fieldErrors = {};
        state.alerts = [];
    },
    updateImage(state, image) {
        state.userData.user_image = `${process.env.VUE_APP_API_HOST}/assets/images/user/${image}`;
        authHelper.setData({
            token : authHelper.getToken(),
            user: state.userData
        });
        state.userData = authHelper.getUserData();
    },
    updateProfileData(state, userData) {
        state.userData.user_name = userData.name;
        state.userData.user_email = userData.email;
        state.userData.user_mobilephone = userData.mobilephone;
        authHelper.setData({
            token : authHelper.getToken(),
            user: state.userData
        });
        state.userData = authHelper.getUserData();
    },
    removeAlert(state, id) {
        const index = Array.from(state.alerts).findIndex(it => it.id === id);

        if (index !== -1) {
            state.alerts.splice(index, 1);
        }
    },
    clearData(state) {
        state.isAuth = false;
        authHelper.clearData();
    },
    reset(state) {
        Object.assign(state, defaultState());
    },
};

const actions = {
    login({ commit, dispatch }, { username, password }) {
        return new Promise((resolve) => {
            commit('attempting');
            apiAuth.login(username, password).then(({ data: { data } }) => {
                commit('success', data);
                resolve(true);
            }).catch((err) => {
                const { data } = err.response;
                dispatch('errorHandler', data);
            }).then(() => {
                commit('attempted');
            });
        });
    },
    logout({ commit }) {
        commit('clearData');

        return Promise.resolve(true);
    },
    errorHandler({ commit }, response) {
        switch (response.message) {
            case 'error_validation':
            commit('validationError', response.data);
            break;

            default:
            commit('failed', { code: 'error_response', type: 'error', message: response.message });
            break;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};